import React, { Component } from "react";

export default class DesignImg extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <svg
        id="1c51936f-ad83-4493-a1e8-5a7ca1846cda"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        // xmlns:xlink="http://www.w3.org/1999/xlink"
        width="1164.07"
        height="555.93"
        viewBox="0 0 1164.07 555.93"
      >
        <defs>
          <linearGradient
            id="ac59aa7e-40f5-4d5f-b82f-fdd6bf7d03ee"
            x1="439.31"
            y1="679.56"
            x2="439.4"
            y2="679.56"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="gray" stopOpacity="0.25" />
            <stop offset="0.54" stopColor="gray" stopOpacity="0.12" />
            <stop offset="1" stopColor="gray" stopOpacity="0.1" />
          </linearGradient>
          <linearGradient
            id="72a3db62-0825-44ad-a640-19754e14ba99"
            x1="186.82"
            y1="533.62"
            x2="458.12"
            y2="533.62"
            // xlink:href="#ac59aa7e-40f5-4d5f-b82f-fdd6bf7d03ee"
          />
          <linearGradient
            id="060ac890-45f2-497a-b51d-740a183b02f3"
            x1="-1193.63"
            y1="706.12"
            x2="-1193.63"
            y2="383.52"
            gradientTransform="translate(1997.33)"
            // xlink:href="#ac59aa7e-40f5-4d5f-b82f-fdd6bf7d03ee"
          />
        </defs>
        <title>design tools</title>
        <path
          d="M1173.17,633.09a83.63,83.63,0,0,1-23,27.6c-1.36,1.09-2.75,2.14-4.16,3.17q-2.85,2-5.84,3.93c-15.49,9.83-33.63,16.55-51.34,21.45q-7.24,2-14.53,3.76-6.15,1.49-12.31,2.78c-1.56.34-3.12.66-4.68,1s-3.35.67-5,1l-2.37.45c-45.82,8.45-92.24,10.06-139,7.94l-2.22-.11-3.55-.18q-14.24-.74-28.51-1.89l-3.6-.29-1.59-.13q-8-.67-16-1.47-10.54-1-21.11-2.21l-.91-.1-.74-.09h0c-25.15-2.83-50.36-6.23-75.6-9.72l-3.57-.5-6.41-.89-5.4-.75h0l-1.6-.22q-12.78-1.79-25.56-3.54l-1.38-.19c-16-2.19-32.09-4.3-48.13-6.22l-2.09-.25h0q-9.85-1.17-19.69-2.23l-5-.53-6.65-.67c-18.43-1.83-36.85-3.29-55.23-4.2q-13.26-.66-26.58-1-11-.25-22-.29-14.92-.07-29.9.17h0l-2.26,0c-14.07.23-28.17.63-42.28,1.11l-2.54.08-.84,0c-30,1.06-60,2.47-89.92,3.48l-7.31.24-1.06,0q-15.6.5-31.17.77l-2.75,0h-.09l-3.34,0-4.64.06q-7.23.07-14.43.08H289.4c-17.62-.05-35.17-.44-52.61-1.35l-1.94-.11c-33.89-1.83-67.4-5.61-100.31-12.48q-5.11-1.07-10.2-2.24A468.41,468.41,0,0,1,57.54,638C47.3,634,37,629.38,29.21,621.56c-19.76-20-12.34-59.17,13.37-70.56,20.11-8.91,43.67-1.66,65.3-5.68a33.38,33.38,0,0,0,3.93-1,54.61,54.61,0,0,0,8-3.3c.88-.44,1.76-.91,2.65-1.4,2-1.09,4-2.3,5.92-3.62a90.88,90.88,0,0,0,9-6.83q1.9-1.62,3.7-3.36A70.77,70.77,0,0,0,152,512.74a46.19,46.19,0,0,0,3-5.64c.47-1,.89-2.08,1.24-3.12a29.06,29.06,0,0,0,1.19-4.62c1.26-7.42-.78-14.66-7.88-20.78a20.94,20.94,0,0,0-2-1.51,30.56,30.56,0,0,0-4.34-2.51c-.61-.29-1.24-.57-1.88-.84-9.14-3.85-20.93-5.33-30.87-8h0a54.5,54.5,0,0,1-8.84-3.07c-1.81-.84-3.61-1.72-5.38-2.64h0l-.47-.26h0a120.39,120.39,0,0,1-39-32,104.24,104.24,0,0,1-7.26-10.54c-.67-1.1-1.32-2.23-1.94-3.36C30,382.15,28.19,341.53,46.47,310.36a97.93,97.93,0,0,1,7.4-10.86q1.32-1.71,2.73-3.36C74,275.61,99,261.7,124.24,251.4c33.88-13.82,69.35-22.55,105.5-28.3q11-1.75,22-3.14c30.7-3.92,61.76-6,92.6-7.58q43.27-2.19,86.92-2.83,14.79-.2,29.61-.17,33.39,0,66.78,1.29,11,.42,22,1,28.21,1.46,56.31,4,13.5,1.22,26.94,2.69c68.24,7.46,135.49,20.11,200.42,39.78q11.05,3.34,22,7a849.57,849.57,0,0,1,80.39,31.07q3.72,1.67,7.42,3.36,24.59,11.28,48.48,24.31a539.15,539.15,0,0,1,60.6,38q11.32,8.3,22,17.32a316.44,316.44,0,0,1,35.11,34.64q1.44,1.67,2.85,3.36,7.32,8.79,13.9,18.21c21.4,30.76,35.76,65.94,46.36,101.88C1181.78,568.65,1188,603.86,1173.17,633.09Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.imageHighlight}
          opacity="0.1"
        />
        <path
          d="M1159.72,525.81h-85.43V417.14h38q-1.41-1.69-2.85-3.36h-35.11V379.14q-10.66-9-22-17.32v52H855.38V299.5h87.81q-3.71-1.69-7.42-3.36H855.38V265.07q-11-3.63-22-7v38H552.3l-.67-.64,81.31-77.18q-13.44-1.48-26.94-2.69l-56.31,53.44v-57.4q-11-.58-22-1v62.09l-66.78-63.38q-14.81,0-29.61.17l90.56,85.95-.67.64H251.76V220q-11,1.39-22,3.14v73H56.6q-1.41,1.65-2.73,3.36H229.74V413.78H47.53c.62,1.13,1.27,2.26,1.94,3.36H229.74V525.81H141.07q-1.8,1.74-3.7,3.36h92.37v111.2q11,1.57,22,3.28V529.17H527.67V668.5q11,0,22,.29V529.17H833.36V699.74l.91.1q10.56,1.18,21.11,2.21V529.17h196.89V697.73c1.68-.31,3.36-.64,5-1s3.12-.63,4.68-1q6.16-1.31,12.31-2.78V529.17h86.12C1160.16,528.05,1159.94,526.93,1159.72,525.81Zm-632.05,0H251.76V417.14H527.67Zm0-112H251.76V299.5h272l3.88,3.06Zm305.69,112H549.69V417.14H833.36Zm0-112H549.69V299.5H833.36Zm218.91,112H855.38V417.14h196.89Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.imageHighlight}
          opacity="0.1"
        />
        <path
          d="M315.15,679.24c0,.11-.08.22-.11.33h0c0-.11.07-.22.12-.33Z"
          transform="translate(-17.96 -172.03)"
          fill="#eaecf0"
        />
        <path
          d="M320.37,674.45l-2.75,0h-.09l-3.34,0-4.64.06-.51-5.27-.47-5-2.18-22.81-.07-.7,0-.31-.61-6.42,9.34-3.5,1.14,9.31.08.69v.08l2.31,18.9.71,5.8.41,3.37.35,2.89v.1Z"
          transform="translate(-17.96 -172.03)"
          fill="#eaecf0"
        />
        <polygon
          points="335.94 507.2 336.05 507.53 335.31 507.53 335.2 507.2 335.94 507.2"
          fill="#3a3768"
        />
        <path
          d="M439.4,679.55l0,0h0Z"
          transform="translate(-17.96 -172.03)"
          fill="#3a3768"
        />
        <path
          d="M498.74,547.48c0,.2,0,.31,0,.31v.12s-8.72,23.83-11.56,44.17q-.29,2-.48,4c-.14,1.41-.25,2.79-.31,4.13-.08,1.57-.1,3.09-.06,4.54,0,.33,0,.67,0,1,0,.67.07,1.36.11,2.07s.1,1.42.16,2.16.12,1.39.19,2.1c2.15,22,10.32,54.21,10.32,54.21s.27.87.62,2.35l-2.26,0c-14.07.23-28.17.63-42.28,1.11l-2.54.08-.84,0c-30,1.06-60,2.47-89.92,3.48l-7.31.24-1.06,0q-15.6.5-31.17.77l-2.75,0a16.85,16.85,0,0,1,2.42-2.73,17.6,17.6,0,0,1,2.45-1.9,55.14,55.14,0,0,1,15.35-6.59,12.24,12.24,0,0,1,3.51-.43l7,.14,1.08,0,10.74.21,92.12,1.83h.23l.65-.13a17.25,17.25,0,0,0,3.11-1.1,10.92,10.92,0,0,0,6.56-8.48c0-.31.08-.64.1-1a11.8,11.8,0,0,0,0-1.46c0-.34,0-.7-.08-1.07s-.1-.74-.17-1.12c-2.22-12.41-6-50.61-6-50.61V600s0-1.63.09-4.37c0-.21,0-.44,0-.67l0-.59c0-.61.07-1.27.11-2,0-.43.06-.87.09-1.33.05-.67.11-1.36.17-2.08a.59.59,0,0,1,0-.13q.06-.68.12-1.38s0-.1,0-.15c1.49-14.75,6.18-38.1,21-46.75,6.95-4.07,11.55-4.89,14.58-4.09,4.42,1.16,5.53,5.76,5.77,8.75,0,.2,0,.39,0,.58A14.61,14.61,0,0,1,498.74,547.48Z"
          transform="translate(-17.96 -172.03)"
          fill="#3a3768"
        />
        <path
          d="M315.15,679.24c0,.11-.08.22-.11.33h0c0-.11.07-.22.12-.33Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <polygon
          points="335.94 507.2 336.05 507.53 335.31 507.53 335.2 507.2 335.94 507.2"
          opacity="0.1"
        />
        <path
          d="M439.4,679.55l0,0h0Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M498.74,547.48c0,.2,0,.31,0,.31s-7.19,19.65-10.62,38.49h0q-.36,2-.66,3.87c-.1.64-.19,1.28-.28,1.92q-.29,2-.48,4c-.14,1.41-.25,2.79-.31,4.13-.08,1.57-.1,3.09-.06,4.54,0,.33,0,.67,0,1,0,.67.07,1.36.11,2.07s.1,1.43.16,2.16.12,1.39.19,2.1.14,1.39.22,2.09c.32,2.83.72,5.8,1.18,8.82,3.13,20.37,8.92,43.19,8.92,43.19s.29.92.64,2.46h0l-2.26,0c-14.07.23-28.17.63-42.28,1.11l-2.54.08-.84,0c-30,1.06-60,2.47-89.92,3.48l-7.31.24-1.06,0q-15.6.5-31.17.77l-2.75,0h-.09a17.18,17.18,0,0,1,2.5-2.83,16.56,16.56,0,0,1,2.46-1.92,55.74,55.74,0,0,1,15.35-6.59,12.59,12.59,0,0,1,3.51-.42l7,.14,1.08,0,10.77.21,92.19,1.82h.16s.27,0,.72-.15a16.16,16.16,0,0,0,3.13-1.13,10.91,10.91,0,0,0,6.47-8.31c0-.31.08-.64.1-1a11.8,11.8,0,0,0,0-1.46c0-.34,0-.7-.08-1.07s-.1-.81-.17-1.23c-2.22-12.41-6-50.61-6-50.61s0-1.63.09-4.37c0-.21,0-.44,0-.67l0-.59c0-.61.07-1.27.11-2,0-.43.06-.87.09-1.33.05-.67.11-1.36.17-2.08a.59.59,0,0,1,0-.13q.06-.68.12-1.38s0-.1,0-.15c.18-1.84.42-3.82.72-5.89,2.08-14.48,7.28-33.39,20.24-41,6.77-4,11.3-4.84,14.34-4.15,4.68,1.07,5.79,5.89,6,8.93,0,.2,0,.39,0,.58A14.61,14.61,0,0,1,498.74,547.48Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M315.15,679.24c0,.11-.08.22-.11.33h0c0-.11.07-.22.12-.33Z"
          transform="translate(-17.96 -172.03)"
          fill="#3a3768"
        />
        <polygon
          points="335.94 507.2 336.05 507.53 335.31 507.53 335.2 507.2 335.94 507.2"
          fill="#3a3768"
        />
        <path
          d="M439.4,679.55l0,0h0Z"
          transform="translate(-17.96 -172.03)"
          fill="#3a3768"
        />
        <path
          d="M496.18,546.63s-13.05,35.66-12.42,57,10.82,61.44,10.82,61.44.44,1.41.91,3.66c-14.07.23-28.17.63-42.28,1.11l-2.54.08-.84,0c-30,1.06-60,2.47-89.92,3.48l-7.31.24-1.06,0q-15.6.5-31.17.77l-2.75,0h-.09l-3.34,0a18,18,0,0,1,5.49-5.77l.27-.19A55.66,55.66,0,0,1,335.29,662a12.59,12.59,0,0,1,3.51-.42l9.24.18,1.08,0,11.13.22L450,663.77a15.09,15.09,0,0,0,3.71-1.21,10.66,10.66,0,0,0,1.14-.61h0a12,12,0,0,0,3-2.45c1.89-2.15,3.15-5.35,2.31-10-2.23-12.41-6-50.61-6-50.61s-.64-46.48,21.64-59.53c9-5.27,14.06-5.09,16.89-3a1.88,1.88,0,0,1,.24.18C496.83,539.68,496.18,546.63,496.18,546.63Z"
          transform="translate(-17.96 -172.03)"
          fill="#3a3768"
        />
        <path
          d="M137.08,634.13l-.36,3.73-2.18,22.89q-5.11-1.07-10.2-2.24l2.55-20.81.86-7.07Z"
          transform="translate(-17.96 -172.03)"
          fill="#eaecf0"
        />
        <polygon
          points="55.12 454.7 109.58 338.79 328.95 355.9 349.17 454.7 55.12 454.7"
          fill="#efc6cd"
        />
        <polygon
          points="55.12 464.81 55.12 454.7 349.17 454.7 349.17 469.48 55.12 464.81"
          fill="#d48a9b"
        />
        <path
          d="M156,609.8l131.56,2.68a1.82,1.82,0,0,0,1.77-2.39l-20.51-55.32-88.61-1.69L154,606.74A2.18,2.18,0,0,0,156,609.8Z"
          transform="translate(-17.96 -172.03)"
          fill="#dfe6f5"
        />
        <path
          d="M156,609.8l131.56,2.68a1.82,1.82,0,0,0,1.77-2.39l-20.51-55.32-88.61-1.69L154,606.74A2.18,2.18,0,0,0,156,609.8Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.15"
        />
        <path
          d="M154.94,607.49l132.92,2.8-18.07-54.73a4.51,4.51,0,0,0-4.19-3.1l-85.42-1.62Z"
          transform="translate(-17.96 -172.03)"
          fill="#dfe6f5"
        />
        <path
          d="M165.92,595.1l15.93-35.05a4.25,4.25,0,0,1,3.86-2.48H225.3a4.23,4.23,0,0,1,4.23,4.23v37.87a4.24,4.24,0,0,1-4.44,4.23l-55.53-2.83A4.23,4.23,0,0,1,165.92,595.1Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.text}
        />
        <path
          d="M244,590.66l.68-20a3.07,3.07,0,0,1,3.06-3h11.7a3.06,3.06,0,0,1,3,2.54l3.44,19.89a3.07,3.07,0,0,1-3,3.59l-15.83.14A3.06,3.06,0,0,1,244,590.66Z"
          transform="translate(-17.96 -172.03)"
          fill="#d1d9ec"
        />
        <path
          d="M89,460.58l44.11-3.68a3,3,0,0,1,3.14,1.77l41.71,94.41-23.28,52.26c.73-1.64,1.27,11.12-4,.06L84.39,467.11C83.5,465.26,86.93,460.84,89,460.58Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.text}
        />
        <path
          d="M89,460.58l44.11-3.68a3,3,0,0,1,3.14,1.77l41.71,94.41-23.28,52.26c.73-1.64,1.27,11.12-4,.06L84.39,467.11C83.5,465.26,86.93,460.84,89,460.58Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.15"
        />
        <path
          d="M89,460.58l46.35-5.92a3,3,0,0,1,3.14,1.77l41.72,94.41-25.24,56.65L86.63,464.87A3,3,0,0,1,89,460.58Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.text}
        />
        <path
          d="M100.57,467.22,134.08,462a3,3,0,0,1,3.25,1.84l35.1,85.86a2.72,2.72,0,0,1-.06,2.2L156.3,585.48a2.71,2.71,0,0,1-4.91,0l-53.09-114A3,3,0,0,1,100.57,467.22Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.imageHighlight}
        />
        <path
          d="M439.4,679.55l0,0h0Z"
          transform="translate(-17.96 -172.03)"
          fill="url(#ac59aa7e-40f5-4d5f-b82f-fdd6bf7d03ee)"
        />
        <path
          d="M458.12,660.68s-.69,1.14-1.7,3l-.09.17c-.9,1.6-2,3.7-3.12,6l-2.54.08-.84,0c-30,1.06-60,2.47-89.92,3.48l-7.31.24-1.06,0q-15.6.5-31.17.77l-2.75,0h-.09l-3.34,0-4.64.06q-7.23.07-14.43.08H289.4c-17.62-.05-35.17-.44-52.61-1.35l-1.94-.11c3.43-7.46,9.56-19.69,14.54-23.6,3.85-3,31.5-6.33,56.93-8.77l2.68-.26h.06l7.1-.66c9.73-.89,18.56-1.61,24.86-2.1l.58-.05-3.28-11-4.75-16,1.35-13.44.11-1.08h-.15a8.83,8.83,0,0,1-4-.5l-47.49-1.64-.86,0h0l-18.24-.65h0c-9.78-.35-16.73-.61-17-.66a4.31,4.31,0,0,1-.84-.23,3.78,3.78,0,0,1-1.16-.7,4.64,4.64,0,0,1-1-1.2l-.2,0-.44,0-2.58.17-1.31.09c-.05-.14-.09-.28-.14-.41-.12-.39-.24-.76-.35-1.14h-.69l-9-.19h-.16s-23.22,1.77-35.35-2.65h0c-4.45-1.62-7.41-4.07-7.18-7.74a8.37,8.37,0,0,1,.52-2.44c-3.9-7.29,15.15-20.59,29.67-16.92a25.7,25.7,0,0,0,12.06.5,15.52,15.52,0,0,0,6-2.73c.18-.13.34-.26.49-.39-.24-.15-.49-.28-.72-.4a11.18,11.18,0,0,0-3.17-1.1l3.94-1.15h.06s14-1.28,23.11-1.79h.06c2.71-.14,5-.23,6.36-.19,6,.17,17.69-4.12,18.19-5.44s5.84,0,5.84,0l4.67-1.82c4.67-1.81,7.34-4.28,7.34-6.1s4.17-3.79,4.17-3.79c1.88-3.16,5.57-6.55,9.44-9.55,3.35-2.59,6.83-4.9,9.41-6.51a189.75,189.75,0,0,1,4-19.24c1.77-5.91,7.26-10.29,9.23-11.71l.72-.48a51.85,51.85,0,0,0-2.2-7.32q-.1-.3-.24-.6c-.2-.47-.41-.93-.62-1.36l-.31-.6c-.51.1-1,.19-1.54.26a35,35,0,0,1-5,.37,34.31,34.31,0,0,1-33.15-25s0,0,0-.06a33.86,33.86,0,0,1-1.2-9,32.92,32.92,0,0,1,1.14-8.64s0,0,0,0c.15-.6.33-1.19.52-1.78a1.59,1.59,0,0,1,.07-.2c.09-.27.18-.55.28-.82a35.17,35.17,0,0,1-4.47.39h-1a21.16,21.16,0,0,1-8.37-1.39h0a11.36,11.36,0,0,1-1.85-1,.24.24,0,0,1-.08-.06A9.38,9.38,0,0,1,278.2,429a10.6,10.6,0,0,0,4.07-7.08c.27-2.16-.09-4.57,1.2-6.33a9.08,9.08,0,0,1,2.34-2c5.32-3.63,9.54-8.61,14.35-12.9s10.63-8,17.1-8.2c8.68-.27,16.32,5.77,24.92,6.91,2.64.35,5.35.23,7.93.89a27.3,27.3,0,0,1,8.05,4.08,20.21,20.21,0,0,1,5.74,4.88,17.21,17.21,0,0,1,2.34,5.59,61.82,61.82,0,0,1,2,12.81c.23,4.53,0,9.09.48,13.59a23.31,23.31,0,0,0,3.84,10.93l.13,0a15,15,0,0,0,1.24,1.52c-.85.27-1.7.51-2.57.72a40.56,40.56,0,0,1-4.39.87,12.79,12.79,0,0,1-2.05.17,6.11,6.11,0,0,1-1.42-.13l.88.59,2.44,1.64,0,0,.92.61,1.85,1.23c.42-1.23,1-1.56,1.67-1.48,1.36-1.28,3.39,1.49,3.39,1.49,1.19,2.28,4.39,4.55,7.22,6.23a57.06,57.06,0,0,0,5.13,2.68c37.37,22.27,35,55.59,37.2,58.23s2.34,12.2,2.34,12.2,5.51,32.49,8,35.3.16,3.79,2.33,6.93,1.67,11.54,1.67,11.54,1.5,19.79,6.84,24.08c4.79,3.85,11.19,36.24,12.46,42.86Z"
          transform="translate(-17.96 -172.03)"
          fill="url(#72a3db62-0825-44ad-a640-19754e14ba99)"
        />
        <path
          d="M239.09,556.44s-5.19,8.17-19.89,4.41-34.15,10.46-28.6,17.48,41.34-2,41.34-2l13.73-2.78-.9-11.43Z"
          transform="translate(-17.96 -172.03)"
          fill="#d38884"
        />
        <path
          d="M239.09,556.44s-5.19,8.17-19.89,4.41-34.15,10.46-28.6,17.48,41.34-2,41.34-2l13.73-2.78-.9-11.43Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M243.87,556l-6.37-.33-3.92,1.14s12.42,1.8,9,18.63l13.39-.81Z"
          transform="translate(-17.96 -172.03)"
          fill="#a36468"
        />
        <path
          d="M243.87,556l-6.37-.33-3.92,1.14s12.42,1.8,9,18.63l13.39-.81Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M328.19,518.36s-17.48,10-22.39,18.31c0,0-4.08,2-4.08,3.76s-2.62,4.24-7.19,6l-4.58,1.8s-5.23-1.31-5.72,0-11.92,5.55-17.81,5.39-28.92,2-28.92,2a20.47,20.47,0,0,1,11.6,22.71l54.42-2.28,20.58-4.58,12.1-12.09Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.dark}
        />
        <path
          d="M328.19,518.36s-17.48,10-22.39,18.31c0,0-4.08,2-4.08,3.76s-2.62,4.24-7.19,6l-4.58,1.8s-5.23-1.31-5.72,0-11.92,5.55-17.81,5.39-28.92,2-28.92,2a20.47,20.47,0,0,1,11.6,22.71l54.42-2.28,20.58-4.58,12.1-12.09Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M248,590.66l-7.7-.15-9-.19S188.8,593.59,189.63,580s33.52-18.36,38.07-14.46c3.45,2.95,11.43,5.33,15.07,6.3,1.16.31,1.87.48,1.87.48Z"
          transform="translate(-17.96 -172.03)"
          fill="#d38884"
        />
        <path
          d="M248,590.66l-7.7-.15c-3.07-10.55.49-16.36,2.51-18.64,1.16.31,1.87.48,1.87.48Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M253.19,591.24l-8,.56-3.8.26c-5.23-15.36,3.22-21.41,3.22-21.41h2.5l4.09.49Z"
          transform="translate(-17.96 -172.03)"
          fill="#a36468"
        />
        <path
          d="M350.09,489.28l-9.48,18s-1.45-18.23-5.67-26.82c-1.08-2.2-2.34-3.76-3.81-4.23-4-1.26,19-26.47,19-26.47.77.16,5.17,3,10.56,6.67,5.93,4,13.07,8.88,17.87,12C387.67,474.24,350.09,489.28,350.09,489.28Z"
          transform="translate(-17.96 -172.03)"
          fill="#d38884"
        />
        <path
          d="M337.93,489.62s-7.62,4.89-9.74,12.08-4.09,20.1-4.09,20.1,3.44,30.88,5.23,32.35,8.6,32.35,8.6,32.35l6.6-4.41-8.66-38.89S341.63,493.23,337.93,489.62Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.dark}
        />
        <path
          d="M337.93,489.62s-7.62,4.89-9.74,12.08-4.09,20.1-4.09,20.1,3.44,30.88,5.23,32.35,8.6,32.35,8.6,32.35l6.6-4.41-8.66-38.89S341.63,493.23,337.93,489.62Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <polygon
          points="353.13 386.48 315.04 386.48 321.21 326.39 353.13 326.39 353.13 386.48"
          fill="#a36468"
        />
        <path
          d="M282.84,679.24h.46l-.86.33Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.jacketColor}
        />
        <path
          d="M354.5,651.87l-7.45,2.86-1,.37-26.82,10.31L309,669.34l-13.92,5.35H289.4c-17.62-.05-35.17-.44-52.61-1.35,3.38-7.41,9.29-19.27,14.11-23.1,3.76-3,30.66-6.24,55.49-8.68,3.1-.3,6.16-.59,9.14-.86l.71-.07c9.86-.9,18.78-1.63,25-2.13l1-.08,7.82-.6.82-.82,1,4.28.83,3.42Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.jacketColor}
        />
        <path
          d="M282.84,679.24h.46l-.86.33Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M354.5,651.87l-7.45,2.86-1,.37-26.82,10.31L309,669.34l-13.92,5.35H289.4c-17.62-.05-35.17-.44-52.61-1.35,3.38-7.41,9.29-19.27,14.11-23.1,3.76-3,30.66-6.24,55.49-8.68,3.1-.3,6.16-.59,9.14-.86l.71-.07c9.86-.9,18.78-1.63,25-2.13l1-.08,7.82-.6.82-.82,1,4.28.83,3.42Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M282.84,679.24h.46l-.86.33Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.jacketColor}
        />
        <path
          d="M315.15,679.24c0,.11-.08.22-.11.33h0c0-.11.07-.22.12-.33Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.jacketColor}
        />
        <polygon
          points="336.05 507.53 335.31 507.53 335.2 507.2 335.94 507.2 336.05 507.53"
          fill={theme.jacketColor}
        />
        <path
          d="M360.87,641.42,360.25,662l0,1.11v.11l-.31,10.19-7.31.24-1.06,0q-15.6.5-31.17.77l-2.75,0h-.09l-3.34,0-4.64.06q-7.23.07-14.43.08H289.4c5.2-3.22,11.93-6.77,19.17-10.32,3.25-1.6,6.62-3.19,10-4.76,9-4.18,18.11-8.13,25.54-11.28l.95-.4c2.88-1.22,5.49-2.31,7.72-3.23,4.82-2,7.88-3.2,8.09-3.28Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.jacketColor}
        />
        <path
          d="M294.08,556.84c1.87,3.9,3.8,7.88,6.89,10.92.49.48,1.34.92,1.78.39a1.26,1.26,0,0,0,.19-.74,9.54,9.54,0,0,0-1.8-5.1c-1-1.54-2.18-2.94-3.07-4.54s-1.91-4.68-3.91-5.1C291.59,552.13,293.51,555.66,294.08,556.84Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M360.65,456.4c-.14.5-.29,1-.45,1.48a33.69,33.69,0,0,1-25.26,22.55c-1.08-2.2-2.34-3.76-3.81-4.23-4-1.26,19-26.47,19-26.47C350.86,449.89,355.26,452.78,360.65,456.4Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M361.85,446.79a33.66,33.66,0,1,1-33.66-33.66A33.59,33.59,0,0,1,361.85,446.79Z"
          transform="translate(-17.96 -172.03)"
          fill="#d38884"
        />
        <path
          d="M341.1,496.79s-7,8.5-5.88,14.06h8.49l6.21-7Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.jacketColor}
        />
        <path
          d="M366,460.9,339.3,497.61s6.86,9.81,10.13,10.3,21.92-43.42,21.92-43.42Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M366.34,460.24,339.63,497s6.86,9.8,10.13,10.29,21.92-43.41,21.92-43.41Z"
          transform="translate(-17.96 -172.03)"
          fill="#a36468"
        />
        <path
          d="M336.2,507.26s-1.31,20.58-2.62,24.67,0,41.66,0,41.66l12.26-5.06-2.13-57.68Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.jacketColor}
        />
        <polygon
          points="335.94 507.2 336.05 507.53 335.31 507.53 335.2 507.2 335.94 507.2"
          opacity="0.1"
        />
        <path
          d="M439.4,679.55l0,0h0Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M454.34,661.51s-.23.38-.61,1-.79,1.39-1.32,2.37a.75.75,0,0,0-.07.12c-.74,1.37-1.62,3.05-2.51,4.88-30,1.06-60,2.47-89.92,3.48l-7.31.24-1.06,0L348.4,663l0-.11-.33-1.12-2-6.66-2-6.77L342,641.12l-.76-2.62-.2-.66-3.26-11.1-4.42-15.07,1.43-14.38h0l.1-1.09,1.29-12.88.18-3.82v0l.1-2,0-.57h0l.22-4.64.66-13.8.34-7.06v0l.06-1.07h0l.68-14.17,1.93-5.79,1-2.88,2.22-6.69.48-1.65v0c.7-2.51,2.11-7.47,3.43-12.24h0l.12-.41h0l.09-.31.94-3.39,1.17-4.35c.44-1.67.73-2.86.8-3.27.11-.71,2-3.85,4.48-8h0c5-8.27,12.52-20.44,13.38-24.52a.44.44,0,0,0,0-.1,5,5,0,0,1,.21-.73c.41-1.22,1-1.55,1.62-1.47a2,2,0,0,1,.79.31,6.29,6.29,0,0,1,1.56,1.5c1.17,2.25,4.3,4.5,7.07,6.17l.54.31.32.19c2.3,1.31,4.16,2.15,4.16,2.15,36.6,22.06,34.32,55.07,36.44,57.68s2.29,12.1,2.29,12.1,5.39,32.19,7.84,35,.17,3.76,2.29,6.87S435.22,594,435.22,594s1.47,19.6,6.7,23.85S454.34,661.51,454.34,661.51Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M455.32,661.19l-.44.76h0c-.35.62-.91,1.6-1.58,2.83l-.07.14c-.76,1.41-1.66,3.12-2.55,5l-.84,0c-30,1.06-60,2.47-89.92,3.48l-7.31.24L349.48,663l0-.11-.33-1.12-2.07-7-2-6.8-2-6.79-.79-2.72h0l-3.42-11.68-4.52-15.39,1.25-12.51.17-1.67L337.15,583v0l.53-11.08.65-13.39.17-3.51.19-4.06.08-1.71.65-13.38,1.93-5.78.83-2.49,1.94-5.85.41-1.24s1.87-6.57,3.68-13.08c.07-.24.14-.48.2-.72.16-.56.31-1.12.47-1.67h0c.16-.56.31-1.11.45-1.66.51-1.82,1-3.52,1.34-4.92.49-1.83.82-3.16.89-3.59.11-.71,2-3.94,4.57-8.14,4.73-7.82,11.63-19,13.09-23.64a7.51,7.51,0,0,0,.2-.73h0a3.81,3.81,0,0,1,.87-2c1.34-1.29,3.33,1.48,3.33,1.48,1.17,2.25,4.3,4.51,7.07,6.17a53,53,0,0,0,5,2.65c36.6,22.06,34.32,55.07,36.44,57.69s2.29,12.09,2.29,12.09,5.39,32.19,7.84,35,.17,3.76,2.29,6.86,1.63,11.44,1.63,11.44,1.47,19.61,6.7,23.86S455.32,661.19,455.32,661.19Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.dark}
        />
        <path
          d="M380.69,468.65c-3.59,5.22-9.44,14.4-11,21,0,0-5.72,5.89-7.85,5.56s2,4.41,2,4.41l-22.47,31.14,3.19-9.57s6.7-23.53,7-25.65,16.57-26.41,17.86-32.52c1-4.89,4.2-.49,4.2-.49C374.78,464.73,377.91,467,380.69,468.65Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M380.69,468c-3.59,5.21-9.44,14.4-11,20.95,0,0-5.72,5.88-7.85,5.56s2,4.41,2,4.41l-22.47,31.14,3.19-9.57s6.7-23.53,7-25.66,16.57-26.4,17.86-32.51c1-4.9,4.2-.49,4.2-.49C374.78,464.08,377.91,466.33,380.69,468Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.dark}
        />
        <path
          d="M410.87,532.52c.17,7.14-10.29,16.89-10.78,17.46s-32.52,27-32.52,27l-23,17.64a19.54,19.54,0,0,1-9,4.16L337.14,583l1.55-32c3.59-4,7.07-8.2,7.15-9.54.16-2.77,6-5.72,6-5.72s4.09-3.43,3.43-5.39S357.44,519,357.44,519c1.47-26.64,28.92-29.25,28.92-29.25s13.24,5.23,22.55,10.78S410.71,525.39,410.87,532.52Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M253.19,591.24l-8,.56c-3.38-5.75,1.27-21.15,1.27-21.15h.65l4.09.49Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M386.36,488.13s-27.45,2.62-28.92,29.25c0,0-2.78,9.32-2.13,11.28s-3.43,5.39-3.43,5.39-5.88,2.94-6,5.72-15,17.94-15,17.94-6.2,7.06-20.58,7.8-21.08,5.14-21.08,5.14-7-4.9-12.1-3.43-29.9,3.43-29.9,3.43-6.59,21.84,1.63,23.21c1,.16,81.9,2.94,81.9,2.94s5.53,2.61,13.86-3.76,23-17.65,23-17.65,32-26.47,32.52-27,11-10.33,10.78-17.46,7.36-26.42-2-32S386.36,488.13,386.36,488.13Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.dark}
        />
        <path
          d="M361.85,446.79a33.59,33.59,0,0,1-1.65,10.43,14.07,14.07,0,0,1-1.24-1.71q-2.34-3.6-4.69-7.2a19.46,19.46,0,0,0-4.77-5.62c-2-1.42-4.84-2-7-.74-1.9,1.12-2.83,3.41-3,5.61a63.69,63.69,0,0,0,.17,6.62,3.65,3.65,0,0,1-.61,2.39,3.92,3.92,0,0,1-2.58,1l-3,.41a2.15,2.15,0,0,1-2.76-1.37c-2.49-4.51-4.21-10.11-8.88-12.28-2.88-1.34-6.68-1.25-8.53-3.83-1.26-1.76-1.09-4.15-.72-6.29a49.65,49.65,0,0,1,1.75-7.12c.53-1.64,1.71-4.91-.91-5.24-1.78-.23-4.24,1.66-5.14,3s-1.12,3.13-1.76,4.66a11.13,11.13,0,0,1-6.15,5.71,17.62,17.62,0,0,1-4.24,1.15,33.66,33.66,0,0,1,65.7,10.34Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M308.3,424c-.91,1.39-1.12,3.12-1.76,4.65a11.14,11.14,0,0,1-6.14,5.71,23.63,23.63,0,0,1-8.43,1.5c-4.66.14-9.86-.57-12.86-4.14a10.53,10.53,0,0,0,4-7c.26-2.14-.09-4.53,1.18-6.28a9,9,0,0,1,2.28-1.93c5.22-3.6,9.34-8.54,14.06-12.78s10.41-7.93,16.75-8.13c8.49-.26,16,5.72,24.4,6.85,2.58.35,5.24.23,7.76.88a26.46,26.46,0,0,1,7.89,4,20.19,20.19,0,0,1,5.63,4.84,17.41,17.41,0,0,1,2.29,5.54,61.86,61.86,0,0,1,2,12.69c.23,4.48,0,9,.48,13.46s1.9,9,4.95,12.3a44,44,0,0,1-6.81,1.57,7.09,7.09,0,0,1-4.33-.34,7.63,7.63,0,0,1-2.64-2.85l-4.69-7.2a19.46,19.46,0,0,0-4.77-5.62c-2-1.42-4.84-2-7-.74-1.9,1.12-2.82,3.41-3,5.61a63.69,63.69,0,0,0,.17,6.62,3.65,3.65,0,0,1-.61,2.39,3.93,3.93,0,0,1-2.59,1l-3,.41a2.15,2.15,0,0,1-2.76-1.37c-2.49-4.52-4.21-10.11-8.88-12.28-2.88-1.34-6.68-1.25-8.53-3.83-1.26-1.76-1.09-4.15-.72-6.29a49.65,49.65,0,0,1,1.75-7.12c.53-1.64,1.71-4.91-.91-5.25C311.66,420.68,309.2,422.57,308.3,424Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.dark}
        />
        <path
          d="M384.44,503.07c2.53-.35,5.19-.58,7.56.39-6.17-2.53-16.21-1.56-21.83,1.92C370.68,506.55,382.48,503.34,384.44,503.07Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M387.39,511.27c6.15.41,12.5,1.27,18.33-.73-4.88-1.68-10.25-.62-15.39-1.13-4.1-.41-8.27-1.83-12.27-.79-1.67.43-7.82,3.26-7.4,5.33A33.23,33.23,0,0,1,387.39,511.27Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M371.1,524.71a9.24,9.24,0,0,1,3.82.4A58.43,58.43,0,0,0,389,526.66c3.62,0,7.52-.55,10.16-3Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M351.29,556a28.18,28.18,0,0,0,13.75,2.5,60.69,60.69,0,0,0,13.84-2.66c2-.59,4.18-1.33,5.35-3.07Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M395.56,560.4a73.46,73.46,0,0,0,30.52,9.45q-8.13-3.26-16.38-6.17a118.64,118.64,0,0,0-17.25-4.62A8.77,8.77,0,0,1,395.56,560.4Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M410.67,554.67a25.79,25.79,0,0,0,5.69.31c1,0,2.19-.14,2.78-1-4.29.18-8.52-.92-12.71-1.87-1.19-.28-3.33-.94-4.33-.23C404,553.24,408.27,554.19,410.67,554.67Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M436.46,644c2.25,3.86,4.53,7.76,7.64,11a56.07,56.07,0,0,0,5.73,4.92c-3.71-9.46-7.48-19-13.42-27.27-1.5-2.08-3.74-5.06-6.47-5.44-.78,2.31,1.19,6.4,2.14,8.57A82.49,82.49,0,0,0,436.46,644Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M327.13,573.26c-.17,1.6-.3,3.37.63,4.68a3.38,3.38,0,0,0,1.9,1.31c-.48-.12-1-4.82-1.12-5.46-.22-1.31,0-3.76-.93-4.73C327.37,570.44,327.28,571.86,327.13,573.26Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M332.33,571.42a10.66,10.66,0,0,0,5,6.77c-1.75-2.16-2.32-5-3.84-7.37-.49-.76-1.06-1.85-2-2A27.49,27.49,0,0,0,332.33,571.42Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M327.93,542.62a12.49,12.49,0,0,1-9.9,1.25c-.75-.22-2.5-1-2.08-2.1s2.45-.34,3.28-.24l4.35.55C324.38,542.18,327.28,543,327.93,542.62Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M313.21,549.74c2.05-.26,3.89,1.16,5.81,1.93a17.7,17.7,0,0,0,6.6.88c1.12,0,2.39-.09,3.08-1C323.49,550.36,318.62,549.05,313.21,549.74Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <polygon
          points="319.97 317.58 320.3 317.58 322.75 326.39 319.97 329.35 319.97 317.58"
          fill="#a36468"
        />
        <g opacity="0.1">
          <path
            d="M283.75,419.76a20.64,20.64,0,0,0-.45,4.35,9.61,9.61,0,0,0,.27-1.4C283.69,421.75,283.68,420.74,283.75,419.76Z"
            transform="translate(-17.96 -172.03)"
          />
          <path
            d="M313.58,420.9a1.76,1.76,0,0,1,1.64,2c.47-1.66.73-3.7-1.31-4-1.78-.22-4.24,1.67-5.14,3.05s-1.12,3.13-1.76,4.66a11.11,11.11,0,0,1-6.14,5.71,23.63,23.63,0,0,1-8.43,1.5c-4.24.13-8.93-.46-12-3.26a10.17,10.17,0,0,1-1.19,1.08c3,3.57,8.2,4.28,12.87,4.14a23.62,23.62,0,0,0,8.42-1.5,11.16,11.16,0,0,0,6.15-5.71c.64-1.53.84-3.26,1.75-4.65S311.8,420.68,313.58,420.9Z"
            transform="translate(-17.96 -172.03)"
          />
          <path
            d="M366.4,455.76a7.09,7.09,0,0,1-4.33-.34,7.72,7.72,0,0,1-2.64-2.85q-2.34-3.6-4.69-7.2a19.3,19.3,0,0,0-4.76-5.62c-2-1.43-4.85-2-7-.74-1.91,1.12-2.83,3.41-3.05,5.61,0,.09,0,.18,0,.27a6.32,6.32,0,0,1,2.73-3.92c2.13-1.26,5-.68,7,.74a19.62,19.62,0,0,1,4.77,5.62q2.34,3.6,4.69,7.2a7.55,7.55,0,0,0,2.64,2.85,7.06,7.06,0,0,0,4.32.34,44.34,44.34,0,0,0,6.82-1.57,14.64,14.64,0,0,1-1.22-1.51A42.93,42.93,0,0,1,366.4,455.76Z"
            transform="translate(-17.96 -172.03)"
          />
          <path
            d="M339.51,453.63a4,4,0,0,1-2.58,1l-3,.41a2.15,2.15,0,0,1-2.76-1.37c-2.49-4.52-4.21-10.11-8.88-12.28-2.88-1.34-6.67-1.25-8.52-3.83a7.36,7.36,0,0,1-.89-5.24c-.05.31-.12.61-.17.91-.36,2.14-.54,4.53.73,6.29,1.85,2.58,5.65,2.49,8.52,3.83,4.68,2.17,6.4,7.76,8.89,12.28A2.86,2.86,0,0,0,332,457a2.93,2.93,0,0,0,1.61.07l3-.41a3.92,3.92,0,0,0,2.58-1,3.59,3.59,0,0,0,.61-2.39h0A3,3,0,0,1,339.51,453.63Z"
            transform="translate(-17.96 -172.03)"
          />
        </g>
        <path
          d="M753.4,689.43l-6.41-.89V593.91l1.31.4,4,1.23,0,3.15,0,2.37,0,3.59.05,4.11.09,8.46v.85l0,1.13,0,2.4,0,1.45,0,3.51,0,2.2.48,42.61v1.14l.17,15v.23Z"
          transform="translate(-17.96 -172.03)"
          fill="#eaecf0"
        />
        <path
          d="M757,689.93l-3.57-.5,0-1.71v-.23l-.17-15v-1.14l-.48-42.61,0-2.2,0-3.51,0-1.45,0-2.4,0-1.13v-.85l-.09-8.46-.05-4.11,0-3.59,0-2.37,0-3.15h3.85l0,3.48,0,2.38,0,2.74,0,3.63.08,9.14v2l0,2.09v1.46l0,1.79,0,2.33h0l.37,44.72v1.15l.12,14.87v.24Z"
          transform="translate(-17.96 -172.03)"
          fill="#d3dae1"
        />
        <path
          d="M757,695.27h0Z"
          transform="translate(-17.96 -172.03)"
          fill="#d3dae1"
        />
        <path
          d="M1146,582.18v81.68q-2.85,2-5.84,3.93l-.08-68v-7.22Z"
          transform="translate(-17.96 -172.03)"
          fill="#eaecf0"
        />
        <path
          d="M1150.16,581v79.7c-1.36,1.09-2.75,2.14-4.16,3.17V582.18Z"
          transform="translate(-17.96 -172.03)"
          fill="#d3dae1"
        />
        <path
          d="M1057.3,696.75c-2.46.5-4.93,1-7.4,1.43l-.09-73.91v-3.2l7.13-3,0,6.78Z"
          transform="translate(-17.96 -172.03)"
          fill="#eaecf0"
        />
        <path
          d="M1062,615.73v80c-1.56.34-3.12.66-4.68,1l-.33-71.87,0-6.78.47-.22h0Z"
          transform="translate(-17.96 -172.03)"
          fill="#d3dae1"
        />
        <path
          d="M638.15,674.61l-6.65-.67-.85-83.34,0-2.38,0-1.59h6.53l0,2.15,0,2.38Z"
          transform="translate(-17.96 -172.03)"
          fill="#eaecf0"
        />
        <path
          d="M643.1,675.14l-5-.53-1-83.45,0-2.38,0-2.15h5.05l0,2.59,0,2.38Z"
          transform="translate(-17.96 -172.03)"
          fill="#d3dae1"
        />
        <polygon
          points="1039.45 445.84 1044.02 443.69 1044.02 453.78 1039.57 455.27 1039.45 445.84"
          opacity="0.1"
        />
        <polygon
          points="1132.19 408.95 1132.19 424.39 1128.04 425.78 1122.11 427.75 1122.1 420.53 1128.04 410.14 1132.19 408.95"
          opacity="0.1"
        />
        <polygon
          points="1132.19 379.27 1132.19 422.02 1039.57 452.89 1038.97 407.17 1132.19 379.27"
          fill="#d48a9b"
        />
        <polygon
          points="611.46 376.3 733.18 353.14 1132.19 379.27 1038.97 407.17 611.46 376.3"
          fill="#efc6cd"
        />
        <polygon
          points="624.23 414.6 624.27 419.56 619.23 419.12 612.68 418.56 612.65 414.6 624.23 414.6"
          opacity="0.1"
        />
        <polygon
          points="738.28 429.36 734.43 429.02 729.03 428.56 729.03 421.88 734.37 423.5 738.23 423.5 738.28 429.36"
          opacity="0.1"
        />
        <polygon
          points="611.46 376.3 611.46 416.08 1039.57 452.89 1038.97 407.17 611.46 376.3"
          fill="#d48a9b"
        />
        <polygon
          points="950.9 423.6 894.98 423.6 894.98 403.31 950.9 407.25 950.9 423.6"
          fill="#d48a9b"
        />
        <polygon
          points="950.9 423.6 894.98 423.6 894.98 403.31 950.9 407.25 950.9 423.6"
          opacity="0.1"
        />
        <polygon
          points="819.87 398.86 819.87 430.92 1034.52 447.25 1034.52 413.11 950.8 408.36 942.48 415.78 908.34 413.41 896.17 404.5 819.87 398.86"
          opacity="0.1"
        />
        <polygon
          points="818.68 397.67 818.68 429.74 1033.33 446.06 1033.33 411.92 949.61 407.17 941.3 414.6 907.15 412.22 894.98 403.31 818.68 397.67"
          fill="#fff"
        />
        <polygon
          points="686.27 389.06 737.04 392.63 736.45 408.76 703.3 408.76 681.13 400.05 686.27 389.06"
          fill="#d48a9b"
        />
        <polygon
          points="686.27 389.06 737.04 392.63 736.45 408.76 703.3 408.76 681.13 400.05 686.27 389.06"
          opacity="0.1"
        />
        <polygon
          points="618.59 384.61 618.59 413.41 813.34 428.85 813.34 398.27 738.23 393.81 730.21 399.75 699.93 397.97 687.46 390.25 618.59 384.61"
          opacity="0.1"
        />
        <polygon
          points="617.4 383.42 617.4 412.22 812.15 427.66 812.15 397.08 737.04 392.63 729.03 398.56 698.74 396.78 686.27 389.06 617.4 383.42"
          fill="#fff"
        />
        <polygon
          points="1034.54 383.53 1061.84 385.32 1016.61 398.86 993.57 397.2 1034.54 383.53"
          opacity="0.1"
        />
        <polygon
          points="1034.54 382.35 1061.84 384.13 1016.61 397.67 993.57 396.01 1034.54 382.35"
          fill="#fff"
        />
        <path
          d="M1049.24,557.45c1.08-.47,2.23.4,3.38.62.65.13,1.33,0,2,.13,1.34.18,2.66,1.07,3.94.62Z"
          transform="translate(-17.96 -172.03)"
          fill="#d3dae1"
        />
        <path
          d="M1047.83,558.26c1.07-.46,2.22.41,3.37.63.66.12,1.34,0,2,.12,1.33.18,2.66,1.08,3.94.63Z"
          transform="translate(-17.96 -172.03)"
          fill="#d3dae1"
        />
        <path
          d="M1044.59,559.9c1.07-.46,2.22.4,3.37.62.66.13,1.33,0,2,.13,1.34.18,2.67,1.08,3.94.62Z"
          transform="translate(-17.96 -172.03)"
          fill="#d3dae1"
        />
        <polygon
          points="850.35 368.55 911.22 372.54 898.25 391.17 831.33 384.02 850.35 368.55"
          opacity="0.1"
        />
        <polygon
          points="849.16 367.36 910.03 371.34 897.06 389.98 830.13 382.83 849.16 367.36"
          fill="#3a3768"
        />
        <polygon
          points="851.84 368.73 904.93 371.98 893.62 387.16 835.25 381.33 851.84 368.73"
          fill="#d5e1f4"
        />
        <path
          d="M757,695.27h0Z"
          transform="translate(-17.96 -172.03)"
          fill="#3a3768"
        />
        <path
          d="M757,695.27h0Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M756.54,695.27h0Z"
          transform="translate(-17.96 -172.03)"
          fill="#3a3768"
        />
        <path
          d="M834.2,693c0,.28,0,.57-.05.85s0,.5-.08.75a16.89,16.89,0,0,1-1.45,5.09h0c-25.15-2.83-50.36-6.23-75.6-9.72l-3.57-.5-6.41-.89-5.4-.75h0a130.08,130.08,0,0,1-17.64-1.65,91.25,91.25,0,0,1-10.9-2.3c-16-2.19-32.09-4.3-48.13-6.22l-2.09-.25c.38-1.7.7-2.73.7-2.73s3.44-13.52,6.3-28.63a0,0,0,0,1,0,0c.63-3.28,1.23-6.62,1.75-9.93.42-2.65.8-5.27,1.12-7.79.18-1.39.33-2.75.46-4.08.07-.66.13-1.32.18-2s.11-1.42.16-2.11.07-1.3.1-1.93l0-.94c0-1.35,0-2.76-.05-4.21a124,124,0,0,0-3.4-21.41c-.28-1.2-.57-2.4-.87-3.57-.09-.38-.19-.75-.29-1.12-3.23-12.51-7-22.73-7-22.73a1.15,1.15,0,0,1,0-.17.57.57,0,0,0,0-.12,2.36,2.36,0,0,0,0-.25c0-.32,0-.81,0-1.4,0-.12,0-.25,0-.38a15.32,15.32,0,0,1,.54-3.1,11.23,11.23,0,0,1,.38-1.06,6.59,6.59,0,0,1,4.5-4.16h0c2.83-.73,7.11,0,13.57,3.83a23.35,23.35,0,0,1,3,2.06c.48.38,1,.78,1.4,1.21,7.4,6.89,11.34,18.26,13.44,28.64.08.37.15.74.22,1.11.25,1.28.46,2.53.65,3.76.34,2.16.61,4.24.81,6.17,0,.52.11,1,.16,1.53s.1,1,.13,1.48c.13,1.56.22,3,.28,4.22.17,3.24.14,5.23.14,5.23v.1s0,.15-.05.43a.19.19,0,0,0,0,.08c0,.12,0,.27,0,.44s0,.29,0,.46q-.06.63-.15,1.47c-.09.86-.19,1.87-.31,3a0,0,0,0,0,0,0c-.08.84-.18,1.75-.28,2.71-.22,2-.46,4.32-.72,6.76-.06.46-.11.92-.16,1.38-.23,2.09-.47,4.27-.72,6.47v0c-.27,2.5-.57,5-.86,7.47-.07.54-.14,1.08-.2,1.61-.74,6-1.48,11.45-2.08,14.84a14.1,14.1,0,0,0-.2,1.52,4.67,4.67,0,0,0,0,.52,10.25,10.25,0,0,0,0,1.36c.49,8.54,9.72,10,9.72,10l41.91-.83,6.22-.12,3.62-.07,32.67-.65h0l3-.06,16.25-.32a11.62,11.62,0,0,1,3.27.39A51.92,51.92,0,0,1,826.39,678a16.69,16.69,0,0,1,3.67,3.2,1.07,1.07,0,0,1,.14.16,17.3,17.3,0,0,1,3.93,9.36c0,.23,0,.46,0,.69C834.21,691.89,834.21,692.43,834.2,693Z"
          transform="translate(-17.96 -172.03)"
          fill="#3a3768"
        />
        <path
          d="M756.54,695.27h0Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M834.2,693c0,.28,0,.57-.05.85s0,.5-.08.75a17.5,17.5,0,0,1-1.5,5.09c-25.15-2.83-50.36-6.23-75.6-9.72l-3.57-.5-6.41-.89-5.4-.75h0a130.08,130.08,0,0,1-17.64-1.65,91.25,91.25,0,0,1-10.9-2.3c-16-2.19-32.09-4.3-48.13-6.22l-2.09-.25h0c.38-1.76.72-2.83.72-2.83s2.81-11,5.48-24.33v0c.19-.92.37-1.84.55-2.77l.27-1.41a0,0,0,0,1,0,0c.62-3.27,1.22-6.63,1.75-9.93.42-2.65.8-5.27,1.12-7.79.18-1.39.33-2.75.46-4.08.07-.66.13-1.32.18-2s.11-1.42.16-2.11.07-1.3.1-1.93l0-.94c0-1.35,0-2.76-.05-4.21a123,123,0,0,0-3.37-21.41q-.42-1.82-.87-3.57c-.1-.38-.19-.75-.29-1.12-3.24-12.55-7-22.83-7-22.83a.32.32,0,0,0,0-.07.57.57,0,0,0,0-.12,2.36,2.36,0,0,0,0-.25c0-.32,0-.81,0-1.4,0-.12,0-.25,0-.38a15.35,15.35,0,0,1,.51-3.1c.11-.35.23-.71.37-1.06a6.61,6.61,0,0,1,4.74-4.31c2.83-.66,7.06.16,13.38,3.86a24.2,24.2,0,0,1,3.12,2.18h0c.47.39.92.78,1.36,1.2,7.34,6.93,11.25,18.28,13.33,28.63.08.37.15.75.22,1.12.25,1.27.46,2.53.65,3.75.34,2.16.6,4.23.8,6.15.05.53.11,1.05.15,1.55s.1,1,.13,1.48c.13,1.56.22,3,.28,4.22.17,3.24.14,5.23.14,5.23l0,.34c0,.06,0,.12,0,.19a.19.19,0,0,0,0,.08c0,.12,0,.27,0,.44s0,.29,0,.46q-.06.63-.15,1.47c-.09.86-.19,1.87-.31,3a0,0,0,0,0,0,0c-.1.83-.19,1.74-.29,2.71-.22,2-.46,4.32-.72,6.76-.06.46-.11.92-.16,1.38-.23,2.09-.48,4.29-.72,6.49v0c-.29,2.5-.58,5-.88,7.46-.07.54-.13,1.08-.2,1.61-.73,6-1.46,11.37-2.06,14.74a13.92,13.92,0,0,0-.2,1.63,4.67,4.67,0,0,0,0,.52,10.25,10.25,0,0,0,0,1.36c.57,8.44,9.72,9.85,9.72,9.85l41.91-.82,6.21-.13,3.63-.07,32.73-.64,3.06-.06,16.19-.32a10.94,10.94,0,0,1,3.27.39,51.33,51.33,0,0,1,14.31,6.15,16.48,16.48,0,0,1,3.72,3.26,1.07,1.07,0,0,1,.14.16,17.13,17.13,0,0,1,3.88,9.4c0,.23,0,.46,0,.69C834.21,691.89,834.21,692.43,834.2,693Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M756.54,695.27h0Z"
          transform="translate(-17.96 -172.03)"
          fill="#3a3768"
        />
        <path
          d="M834.27,699.84l-1.65-.19h0c-25.15-2.83-50.36-6.23-75.6-9.72l-3.57-.5-6.41-.89-5.4-.75h0a130.08,130.08,0,0,1-17.64-1.65,91.25,91.25,0,0,1-10.9-2.3c-16-2.19-32.09-4.3-48.13-6.22a40.91,40.91,0,0,1,1-4.16s9.5-37.41,10.09-57.3c.21-7.11-1.2-15.91-3.11-24.3h0c-.28-1.21-.56-2.41-.86-3.59l-.27-1.12C668.43,574,664.4,563,664.4,563a16.25,16.25,0,0,1,.23-4.07,10.89,10.89,0,0,1,.24-1.07,8.16,8.16,0,0,1,2.58-4.32h0a1.33,1.33,0,0,1,.19-.14c2.63-2,7.35-2.14,15.75,2.78a24.63,24.63,0,0,1,4.69,3.59c.4.38.8.78,1.18,1.19,6.75,7.31,10.33,18.51,12.21,28.53l.21,1.11c.22,1.25.41,2.48.59,3.67,0,0,0,.07,0,.1h0c.23,1.58.42,3.09.58,4.53,0,0,0,0,0,0a119.31,119.31,0,0,1,.72,12.77s-.39,3.95-1,9.64c-.23,2.23-.5,4.73-.79,7.37,0,.13,0,.26,0,.4l-.15,1.4c-.51,4.61-1.07,9.53-1.64,14.09-.06.56-.13,1.11-.2,1.65-.64,5.13-1.28,9.69-1.81,12.66-2.08,11.58,9.5,13.36,9.5,13.36l39.54-.78,6.2-.12,3.63-.08,1.52,0h.49l31.36-.62,3,0,18-.36a11.24,11.24,0,0,1,3.27.4,51.58,51.58,0,0,1,14.32,6.14,17,17,0,0,1,3.37,2.86,1.63,1.63,0,0,1,.17.2A17.32,17.32,0,0,1,834.27,699.84Z"
          transform="translate(-17.96 -172.03)"
          fill="#3a3768"
        />
        <polygon
          points="957.67 347.05 969.9 373.25 967.85 373.25 953.51 347.36 957.67 347.05"
          fill={theme.text}
        />
        <polygon
          points="957.67 347.05 969.9 373.25 967.85 373.25 953.51 347.36 957.67 347.05"
          opacity="0.1"
        />
        <polygon
          points="957.67 373.25 969.9 373.25 969.9 375.99 957.67 376.3 957.67 373.25"
          fill={theme.text}
        />
        <polygon
          points="957.67 373.25 969.9 373.25 969.9 375.99 957.67 376.3 957.67 373.25"
          opacity="0.1"
        />
        <path
          d="M880.5,422.67v91.49a6.79,6.79,0,0,0,6.79,6.79h152.5a6.75,6.75,0,0,0,6.75-6.88l-1.73-91.57a6.75,6.75,0,0,0-6.75-6.62H887.29A6.79,6.79,0,0,0,880.5,422.67Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.text}
        />
        <path
          d="M880.5,422.67v91.49a6.79,6.79,0,0,0,6.79,6.79h152.5a6.75,6.75,0,0,0,6.75-6.88l-1.73-91.57a6.75,6.75,0,0,0-6.75-6.62H887.29A6.79,6.79,0,0,0,880.5,422.67Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M875,422.67v91.49a6.79,6.79,0,0,0,6.79,6.79h152.5a6.74,6.74,0,0,0,6.74-6.88l-1.73-91.57a6.75,6.75,0,0,0-6.74-6.62H881.83A6.79,6.79,0,0,0,875,422.67Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.text}
        />
        <path
          d="M881,428.39v80.55a6.79,6.79,0,0,0,6.79,6.79H1029a6.75,6.75,0,0,0,6.75-6.75V428.34a6.75,6.75,0,0,0-6.75-6.74H887.79A6.79,6.79,0,0,0,881,428.39Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.imageHighlight}
        />
        <polygon
          points="924.14 347.42 937.55 373.25 967.85 373.25 952.7 343.7 924.14 347.42"
          fill={theme.text}
        />
        <polygon
          points="913.46 373.25 911.22 375.99 957.67 375.99 957.67 373.25 913.46 373.25"
          fill={theme.text}
        />
        <path
          d="M735.56,450.44c-3.33-9.36-3.31-19.75-7.35-28.82a35.11,35.11,0,0,1-1.69-4,11.72,11.72,0,0,1-.46-2.61l-.25.06-.25.07-.25.1h0l-.23.14a8.75,8.75,0,0,0,.23.88,33.67,33.67,0,0,0,1.71,4c4.12,9.12,4.09,19.55,7.48,29a2.72,2.72,0,0,0,.63,1.11,1.49,1.49,0,0,0,.51.31C735.61,450.57,735.58,450.51,735.56,450.44Zm0,0c-3.33-9.36-3.31-19.75-7.35-28.82a35.11,35.11,0,0,1-1.69-4,11.72,11.72,0,0,1-.46-2.61l-.25.06-.25.07-.25.1h0l-.23.14a8.75,8.75,0,0,0,.23.88,33.67,33.67,0,0,0,1.71,4c4.12,9.12,4.09,19.55,7.48,29a2.72,2.72,0,0,0,.63,1.11,1.49,1.49,0,0,0,.51.31C735.61,450.57,735.58,450.51,735.56,450.44Zm0,0c-3.33-9.36-3.31-19.75-7.35-28.82a35.11,35.11,0,0,1-1.69-4,11.72,11.72,0,0,1-.46-2.61l-.25.06-.25.07-.25.1h0l-.23.14a8.75,8.75,0,0,0,.23.88,33.67,33.67,0,0,0,1.71,4c4.12,9.12,4.09,19.55,7.48,29a2.72,2.72,0,0,0,.63,1.11,1.49,1.49,0,0,0,.51.31C735.61,450.57,735.58,450.51,735.56,450.44Zm0,0c-3.33-9.36-3.31-19.75-7.35-28.82a35.11,35.11,0,0,1-1.69-4,11.72,11.72,0,0,1-.46-2.61l-.25.06-.25.07-.25.1h0l-.23.14a8.75,8.75,0,0,0,.23.88,33.67,33.67,0,0,0,1.71,4c4.12,9.12,4.09,19.55,7.48,29a2.72,2.72,0,0,0,.63,1.11,1.49,1.49,0,0,0,.51.31C735.61,450.57,735.58,450.51,735.56,450.44Zm0,0c-3.33-9.36-3.31-19.75-7.35-28.82a35.11,35.11,0,0,1-1.69-4,11.72,11.72,0,0,1-.46-2.61l-.25.06-.25.07-.25.1h0l-.23.14a8.75,8.75,0,0,0,.23.88,33.67,33.67,0,0,0,1.71,4c4.12,9.12,4.09,19.55,7.48,29a2.72,2.72,0,0,0,.63,1.11,1.49,1.49,0,0,0,.51.31C735.61,450.57,735.58,450.51,735.56,450.44Zm0,0c-3.33-9.36-3.31-19.75-7.35-28.82a35.11,35.11,0,0,1-1.69-4,11.72,11.72,0,0,1-.46-2.61l-.25.06-.25.07-.25.1h0l-.23.14a8.75,8.75,0,0,0,.23.88,33.67,33.67,0,0,0,1.71,4c4.12,9.12,4.09,19.55,7.48,29a2.72,2.72,0,0,0,.63,1.11,1.49,1.49,0,0,0,.51.31C735.61,450.57,735.58,450.51,735.56,450.44Zm0,0c-3.33-9.36-3.31-19.75-7.35-28.82a35.11,35.11,0,0,1-1.69-4,11.72,11.72,0,0,1-.46-2.61l-.25.06-.25.07-.25.1h0l-.23.14a8.75,8.75,0,0,0,.23.88,33.67,33.67,0,0,0,1.71,4c4.12,9.12,4.09,19.55,7.48,29a2.72,2.72,0,0,0,.63,1.11,1.49,1.49,0,0,0,.51.31C735.61,450.57,735.58,450.51,735.56,450.44Zm173.75,93.2h0l-.77-.14,1-.22h0a1.53,1.53,0,0,0,.29-.07h0c1.11-.24,2.21-.51,3.29-.8h0l1.13-.32h0l.16-.05c9.32-2.75-1.55-5.28-15.37-7.16H899c-14.92-2-33.22-3.31-33.22-3.31l-5.73.76H860c-7,.92-18.05,2.44-19.81,3-2.14.71-20.3,1.58-26.63,1.86a2.76,2.76,0,0,0-.94-1l-18.67-.86v2.57l0,0-.14-.06a25.61,25.61,0,0,0-2.53-10l-.14-.28c-4.82-9.14-5.79-11.43-5.79-11.43h0c0-.16-.08-.32-.13-.49-1.62-5.62-7.59-15.39-17.71-29.41l-.35-.49-1.27-6.22-.22-1.09H759.3a83.3,83.3,0,0,1,4.42-15.81c.13-.32.26-.64.4-.95l.08-.18c.14-.33.3-.66.45-1,.37,0,.74,0,1.11,0h0A30.43,30.43,0,0,0,795,432.19a.19.19,0,0,0,0-.08q.06-.93.06-1.86a29.77,29.77,0,0,0-4-15c-.08-.14-.16-.28-.25-.42l-.16-.27-.36-.56c2.28-.54,5,.5,7-.78a5.12,5.12,0,0,0,1.71-2.06,10.71,10.71,0,0,0,1-3s0,0,0,0,0,0,0,0a0,0,0,0,0,0,0,1,1,0,0,0,0-.17.13.13,0,0,0,0-.06,11.83,11.83,0,0,0,.15-2.06,11.1,11.1,0,0,0-.7-4.16,11.46,11.46,0,0,0-6.44-6.46,43.63,43.63,0,0,0-4.68-1.27c-6.4-1.71-11.81-5.93-18-8.28a32.65,32.65,0,0,0-13.49-2.08,19.3,19.3,0,0,0-8,2,34.25,34.25,0,0,0-5.34,3.87C739.05,393,734,396,730.13,400.19a23.92,23.92,0,0,0-1.94,2.4c-.34.49-.65,1-1,1.5a2.68,2.68,0,0,0-2.41-1h0a3.92,3.92,0,0,0-.49,0,9.7,9.7,0,0,0-1.24.13c-1,.17-8.45,2.14-8.45,3.16a35.19,35.19,0,0,0-8.56,5.26c-6,5.49-7.34,14.19-8.1,22.21a205.81,205.81,0,0,0-1,28c.14,3.4.41,6.8.25,10.2a75.86,75.86,0,0,1-1.77,11.88q-1.29,6.1-2.79,12.16c-.48,2-1.25,4.23-3.21,4.86l.73.1a3.51,3.51,0,0,1-.73.35,21.84,21.84,0,0,0,2.54.25h.59a6.9,6.9,0,0,0,1.43-.17,5.34,5.34,0,0,0,1.81-.84c.08-.2.15-.4.22-.61a3.38,3.38,0,0,0,1.2-1.86,13.23,13.23,0,0,1-.2,3.38c0,.16-.06.33-.1.49a13.8,13.8,0,0,1-3.44,6.52l1-.76a14.71,14.71,0,0,1-1,1.21q2.16-1.62,4.32-3.31h0a2.07,2.07,0,0,0,.25-.19h0l2.46-1.94c0,.24,0,.55,0,.94s0,.62,0,1h0c0,.14,0,.29,0,.45-.2,6.9-.49,23.85,1.08,27.9.09.24.19.48.27.71,1.79,4.61,2.56,6.6,2.33,9-.16,1.67,1.09,6.45,1.78,10.25a12.72,12.72,0,0,1,.32,4.63,6.6,6.6,0,0,0,.18,2.76c.09.44.2.91.32,1.4,0,.17.08.35.13.53.91,3.64,2.2,8.14.85,9.93a7.93,7.93,0,0,0-1,2c-1.11,3-1.29,7.1-2.57,8.76-1.5,1.93-1,5.36-.88,5.8a.18.18,0,0,1,0,.05s-.07.39-.21,1c-.17.84-.44,2.13-.78,3.56l0,.1a50.87,50.87,0,0,1-1.73,5.93s0,0,0,0c-.51,1.36-1,2.34-1.57,2.53-2,.73-3,10.12-3,10.12s-4.58,7.43-3.71,9.26a12.26,12.26,0,0,0,.65,1.23l-.44.68c-2.45,3.93-6,11.07-2.56,14.91a17,17,0,0,0,4.1,3.13c-.18.4-.37.83-.57,1.3-3.78,8.86-9.6,29.44,12.79,38.12a71,71,0,0,0,6.79,2.23,91.25,91.25,0,0,0,10.9,2.3,133.59,133.59,0,0,0,16,1.43c2.38.08,4.73.1,7,.08s4.33-.07,6.39-.16q1.83-.07,3.57-.18A186.76,186.76,0,0,0,777.46,685l32-5.73s13.44.48,18.39,3.32l.15.09s.81-.47,2.17-1.39l0,0c.59-.4,1.29-.88,2.06-1.45,5.07-3.73,13.53-11,19.07-21.22l.11-.19,1.09-.14.25,0,.78-.11,1.62-.23h.1l.19,0c4.05-.59,7.88-1.24,7.88-1.24s.15,4.47.33,9.65c.06,1.58.11,3.23.17,4.83.19,5.48.36,10.46.36,10.63s4.12,11,8.73,21.92l3.6.29q14.26,1.14,28.51,1.89l3.55.18,2.22.11c-1.6-9.69-2.86-18.93-2.86-18.93l-5.94-27.67s-.62-5.73-5.07-31.2c-3.6-20.64-24.8-18.81-32.74-17.36-.81.15-1.47.29-2,.4v-1.55s-15.23,1.28-29,1.9l-3.35.14c-3.19.12-6.22.19-8.88.19a65,65,0,0,1-7-.28c-10.63-1.22-22.75,2.43-22.75,2.43s-15.49,2.51-17.56,1.59a5.33,5.33,0,0,0-1.75-.36c-.31,0-.64,0-1,0a1.6,1.6,0,0,0,1-1.78c-.62-2.56-.87-6.1.87-8.54.76-1.08,2-2.78,3.11-4.33l2.7-3.71,0-.29.07-1.09.65-9.72,1.56-9,.1-.57.14-.8.1-.58.3.1h0c4.43,1.54,9.45,2.62,13,1.38l.07,0a5.94,5.94,0,0,0,.82-.35h.16l0,.67.06,1.17,16.69-.91h.25s.65-3.22,1.35-7.66c.05-.36.11-.73.17-1.11s.15-1,.22-1.46c0-.23.07-.47.1-.71l.67,0h.33c7.74-.28,18.54-.94,22.94-2.54h0a5,5,0,0,0,1.51-.81c1.87-1.62,8.58-3.94,15.17-5.94h0l2.63-.78c1.91-.56,3.75-1.08,5.38-1.54,3.78-1,6.48-1.74,6.48-1.74s26,2.41,45.42-3.2h0l.32-.09C922.54,547.25,918,545.29,909.31,543.64Zm-184.49-130c0,.32.06.57.11.89,0,0,0,0,0,0s0,0,0,0,0,0,0,0,0,0,0,0a2.5,2.5,0,0,0,.06.38c0,.13,0,.26.08.39a8.75,8.75,0,0,0,.23.88,33.67,33.67,0,0,0,1.71,4c4.12,9.12,4.09,19.55,7.48,29a2.72,2.72,0,0,0,.63,1.11,1.49,1.49,0,0,0,.51.31l.24.08h0l.28,0-.11.19a1,1,0,0,1-.08.14l-.07.11c-1.34,2.26-2.77,4.48-4.21,6.44a9.4,9.4,0,0,0-3.47,1.42l-.56.37-.24.18c-.35-1.72-.83-3.42-1.27-5.12a118.18,118.18,0,0,1-3.86-27.74c0-.2,0-.4,0-.6,0-.43,0-.86,0-1.29,0-2.42.06-4.83.21-7.25a6,6,0,0,1,.85-3.18h0A2.19,2.19,0,0,1,724.82,413.63Zm10.74,36.81c-3.33-9.36-3.31-19.75-7.35-28.82a35.11,35.11,0,0,1-1.69-4,11.72,11.72,0,0,1-.46-2.61l-.25.06-.25.07-.25.1h0l-.23.14a8.75,8.75,0,0,0,.23.88,33.67,33.67,0,0,0,1.71,4c4.12,9.12,4.09,19.55,7.48,29a2.72,2.72,0,0,0,.63,1.11,1.49,1.49,0,0,0,.51.31C735.61,450.57,735.58,450.51,735.56,450.44Zm0,0c-3.33-9.36-3.31-19.75-7.35-28.82a35.11,35.11,0,0,1-1.69-4,11.72,11.72,0,0,1-.46-2.61l-.25.06-.25.07-.25.1h0l-.23.14a8.75,8.75,0,0,0,.23.88,33.67,33.67,0,0,0,1.71,4c4.12,9.12,4.09,19.55,7.48,29a2.72,2.72,0,0,0,.63,1.11,1.49,1.49,0,0,0,.51.31C735.61,450.57,735.58,450.51,735.56,450.44Zm0,0c-3.33-9.36-3.31-19.75-7.35-28.82a35.11,35.11,0,0,1-1.69-4,11.72,11.72,0,0,1-.46-2.61l-.25.06-.25.07-.25.1h0l-.23.14a8.75,8.75,0,0,0,.23.88,33.67,33.67,0,0,0,1.71,4c4.12,9.12,4.09,19.55,7.48,29a2.72,2.72,0,0,0,.63,1.11,1.49,1.49,0,0,0,.51.31C735.61,450.57,735.58,450.51,735.56,450.44Zm0,0c-3.33-9.36-3.31-19.75-7.35-28.82a35.11,35.11,0,0,1-1.69-4,11.72,11.72,0,0,1-.46-2.61l-.25.06-.25.07-.25.1h0l-.23.14a8.75,8.75,0,0,0,.23.88,33.67,33.67,0,0,0,1.71,4c4.12,9.12,4.09,19.55,7.48,29a2.72,2.72,0,0,0,.63,1.11,1.49,1.49,0,0,0,.51.31C735.61,450.57,735.58,450.51,735.56,450.44Zm0,0c-3.33-9.36-3.31-19.75-7.35-28.82a35.11,35.11,0,0,1-1.69-4,11.72,11.72,0,0,1-.46-2.61l-.25.06-.25.07-.25.1h0l-.23.14a8.75,8.75,0,0,0,.23.88,33.67,33.67,0,0,0,1.71,4c4.12,9.12,4.09,19.55,7.48,29a2.72,2.72,0,0,0,.63,1.11,1.49,1.49,0,0,0,.51.31C735.61,450.57,735.58,450.51,735.56,450.44Zm0,0c-3.33-9.36-3.31-19.75-7.35-28.82a35.11,35.11,0,0,1-1.69-4,11.72,11.72,0,0,1-.46-2.61l-.25.06-.25.07-.25.1h0l-.23.14a8.75,8.75,0,0,0,.23.88,33.67,33.67,0,0,0,1.71,4c4.12,9.12,4.09,19.55,7.48,29a2.72,2.72,0,0,0,.63,1.11,1.49,1.49,0,0,0,.51.31C735.61,450.57,735.58,450.51,735.56,450.44Z"
          transform="translate(-17.96 -172.03)"
          fill="url(#060ac890-45f2-497a-b51d-740a183b02f3)"
        />
        <path
          d="M769,455.7a23.32,23.32,0,0,0-3.84,5.94c-.15.33-.3.65-.44,1-4.42,10-5.92,24.15-5.92,24.15s-2.74-1.23-6.62-3.15c-7.23-3.58-18.39-9.54-22.9-14.29-2-2.15-2.72-4.05-1.06-5.38.36-.29.73-.62,1.1-1a31.8,31.8,0,0,0,3.49-4.14c1.44-2,2.86-4.23,4.2-6.52.79-1.34,1.54-2.69,2.24-4l.28-.52c3-5.69,5.19-10.55,5.19-10.55s1,.32,2.62.89C754.81,440.8,775.38,448.91,769,455.7Z"
          transform="translate(-17.96 -172.03)"
          fill="#efb7b9"
        />
        <path
          d="M905.88,687.39s1.22,9.06,2.77,18.62l-3.55-.18q-14.24-.74-28.51-1.89c-5.4-12.51-11-27.36-11-27.59s-.17-5.12-.36-10.58c-.06-1.92-.13-3.9-.19-5.76h0c-.1-2.82-.19-5.36-.24-6.94,0-1.08-.06-1.72-.06-1.72s-5.14.9-9.76,1.53l-2.05.27c-1.06.13-2,.23-2.85.29a7.33,7.33,0,0,1-2.21,0c-1.58-.61,1.7-16,1.7-16l8.16-19.75,2.28-5.5,1-.25c.49-.12,1.15-.26,1.94-.41,7.79-1.43,28.6-3.25,32.13,17.29,4.37,25.37,5,31.07,5,31.07Z"
          transform="translate(-17.96 -172.03)"
          fill="#efb7b9"
        />
        <path
          d="M913.77,728H911.3a0,0,0,0,1,0,0h2.44Z"
          transform="translate(-17.96 -172.03)"
          fill="#efb7b9"
        />
        <path
          d="M905.88,687.39s1.22,9.06,2.77,18.62l-3.55-.18q-14.24-.74-28.51-1.89c-5.4-12.51-11-27.36-11-27.59s-.17-5.12-.36-10.58c-.06-1.92-.13-3.9-.19-5.76h0c-.1-2.82-.19-5.36-.24-6.94,0-1.08-.06-1.72-.06-1.72s-5.14.9-9.76,1.53l-2.05.27c-1.06.13-2,.23-2.85.29a7.33,7.33,0,0,1-2.21,0c-1.58-.61,1.7-16,1.7-16l8.16-19.75,2.28-5.5,1-.25c.49-.12,1.15-.26,1.94-.41,7.79-1.43,28.6-3.25,32.13,17.29,4.37,25.37,5,31.07,5,31.07Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.05"
        />
        <path
          d="M913.77,728H911.3a0,0,0,0,1,0,0h2.44Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.05"
        />
        <path
          d="M905.1,705.83q-14.24-.74-28.51-1.89l-3.6-.29-1.59-.13c-4.48-10.81-8.46-21.38-8.46-21.57s-.17-5.12-.36-10.58c-.23-6.82-.49-14.42-.49-14.42l-.67.11-.28.05-.12,0-.24,0-1.61.27-.88.14c-1.59.26-3.51.55-5.39.82l-.42.06-1.1.14-1,.12h0c-.77.1-1.5.18-2.16.24l-.81.07a7,7,0,0,1-2.21,0c-1.58-.61,1.7-16,1.7-16l10.44-25.25.36-.1c.55-.14,1.71-.41,3.28-.68.59-.1,1.24-.2,1.94-.29,9.06-1.16,26.3-.83,29.49,17.7,4.37,25.37,5,31.07,5,31.07L903.24,693S904,698.7,905.1,705.83Z"
          transform="translate(-17.96 -172.03)"
          fill="#efb7b9"
        />
        <path
          d="M862.58,671.37c-.23-6.82-.49-14.43-.49-14.43s-10,1.75-14.66,2.09l.94-3.18s17.12-4.73,17.48-2.06C866.11,655.66,863.91,665.6,862.58,671.37Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M862.94,611.48v7.23s-.85,13-7.53,32.89c-.14.43-.29.85-.45,1.27a45.38,45.38,0,0,1-2.48,5.58c-1.88.26-3.7.48-5.05.58a7.31,7.31,0,0,1-2.21,0c-1.58-.61,1.69-16,1.69-16l10.44-25.24.37-.1,2.27-5.51S861.11,611.82,862.94,611.48Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M861,610.34v8.37s-.85,13-7.53,32.9c-.17.52-.36,1-.55,1.53s-.44,1.16-.69,1.72c-.55,1.33-1.17,2.62-1.82,3.86h0c-5.23,9.91-13.2,17-18.26,20.9-.74.57-1.43,1.07-2,1.49l-.05,0c-1,.68-1.72,1.17-2.18,1.46s-.5.31-.5.31c-4.74-2.91-18.21-3.4-18.21-3.4l-31.44,5.71A182.23,182.23,0,0,1,757,687.55l-3.57.17c-2.06.08-4.2.13-6.39.14-1.77,0-3.57,0-5.4-.07h0a130.08,130.08,0,0,1-17.64-1.65,88.09,88.09,0,0,1-9.52-2.11,67,67,0,0,1-6.59-2.2c-22-8.64-16.27-29.13-12.56-38,.2-.47.39-.9.57-1.3.82-1.81,1.43-2.87,1.43-2.87l1.46-3.53v0l2.39-5.79.53-1.27.15-.37,1.77-4.29,25-3.24L747,618.79l5.59-.72,3.79-.49,7.23-.94,2.72-.35a33.85,33.85,0,0,1,5.07-.4,7.09,7.09,0,0,1,2.7.4c2,.91,17.24-1.58,17.24-1.58s11.89-3.64,22.33-2.43a124.22,124.22,0,0,0,15.51.1h0l1.28-.06,1.66-.07.36,0C846,611.62,861,610.34,861,610.34Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.dark}
        />
        <path
          d="M771.05,635.46s-12,27.31-12.5,27.79-.48,9,0,8.5,17.12-37.38,17.12-37.38Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M829.19,612.36s-6.07,3.92-7.89,7.08-18.45,34.59-22.57,39.2a100.69,100.69,0,0,0-9.23,13.13c-.48.83-.48,6.05,2.43,1.07s2.19-5.82,7.89-12,12-20.15,14.44-22.94,5.83-11.17,10.08-16.15l8.14-9.51Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M830.65,666.29s-4.25-2.91-8.25,2.06S830.65,666.29,830.65,666.29Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M835.87,667.79s-3.52,6.14-5.22,6.63S835.87,667.79,835.87,667.79Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M830.65,669.32s-2.79,4.86-5.22,4.37Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M811,538.11s25.73-1.09,28.28-1.94,25.12-3.76,25.12-3.76,66.88,4.73,47.83,10.44-44.91,3.27-44.91,3.27-25.25,6.56-29.13,10-32.53,3.52-32.53,3.52Z"
          transform="translate(-17.96 -172.03)"
          fill="#efb7b9"
        />
        <path
          d="M811,538.11s25.73-1.09,28.28-1.94,25.12-3.76,25.12-3.76,66.88,4.73,47.83,10.44-44.91,3.27-44.91,3.27-25.25,6.56-29.13,10-32.53,3.52-32.53,3.52Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.05"
        />
        <path
          d="M719.47,479.49s-23.55,8-12.14,28.4,26.1,30,26.1,30l37.87,26.22s15.9,9.1,23.18,5.34l11.89-1,2-31.2s-10,7.77-20.88-3-24.28-18.09-25.37-23.91S733.18,474.51,719.47,479.49Z"
          transform="translate(-17.96 -172.03)"
          fill="#a36468"
        />
        <path
          d="M793.87,545.52s12.26,4.37,11.78,4.61-11.78,4.49-11.78,4.49l.85,16.63,16.63-.91s6.07-30.28.85-33.32l-18.33-.85Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.jacketColor}
        />
        <path
          d="M793.87,545.52s12.26,4.37,11.78,4.61-11.78,4.49-11.78,4.49l.85,16.63,16.63-.91s6.07-30.28.85-33.32l-18.33-.85Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M769,455.7a23.32,23.32,0,0,0-3.84,5.94c-.15.33-.3.65-.44,1-8.93,0-15.35-6.94-20.83-13.15-1-1.15-3.53.59-4.36-.7-.09-.15-.18-.3-.28-.45l.28-.52c3-5.69,5.19-10.55,5.19-10.55s1,.32,2.62.89C754.81,440.8,775.38,448.91,769,455.7Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M795,431.55a30.1,30.1,0,0,1-29.82,30.09h-.29a30.05,30.05,0,0,1-22.58-10.2,30.66,30.66,0,0,1-2.76-3.65A30.11,30.11,0,1,1,795,431.55Z"
          transform="translate(-17.96 -172.03)"
          fill="#efb7b9"
        />
        <path
          d="M764.38,618.22s-2.29,2.8-4.82,5.41c-1.91,2-3.95,3.83-5.26,4.3-3,1.1-16.75,11.53-16.75,11.53s-10.92,7.41-13.71,9.59-12.87.85-12.87.85-9.7-2.12-15.71-6a39.05,39.05,0,0,1,2-4.16l6.31-15.3,25-3.23Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M763.89,616.28s-2.28,2.8-4.81,5.41c-1.91,2-4,3.83-5.26,4.3-3,1.09-16.75,11.53-16.75,11.53s-10.93,7.41-13.72,9.59-12.86.85-12.86.85-13.84-3-18.7-8.5c-3.4-3.83.12-10.93,2.52-14.84,1-1.67,1.85-2.76,1.85-2.76Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.jacketColor}
        />
        <path
          d="M781.86,522.21c-8.26-.73-35.45-34-35.45-34l.62-.85,5.7-7.89h13.33l1.47,7.28c10.14,14.22,16.11,24.11,17.73,29.77C786.43,520.64,785.32,522.52,781.86,522.21Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.jacketColor}
        />
        <path
          d="M781.86,522.21c-8.26-.73-35.45-34-35.45-34l.62-.85a153.54,153.54,0,0,1,13.71,14.32c19.9,23.42,23.84,16.88,24.52,14.84C786.43,520.64,785.32,522.52,781.86,522.21Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M763.89,616.28s-2.28,2.8-4.81,5.41a13.64,13.64,0,0,1-4.17.9c-3.16-.12-10.44,4.86-10.44,4.86s-12.86-.73-15.29.6-11.78,1.58-11.78,1.58c-17.11,4.88-21.84-2.53-23.09-5,1-1.67,1.85-2.76,1.85-2.76Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M793.61,544c0,.47-.09.94-.15,1.39s-.12.91-.19,1.34a22,22,0,0,1-2.19,7.09c-2.18,3.64-8.86,17.84-8.86,17.84l-.45,2.62-.23,1.37L781.3,577l-1.63,9.57-.73,11.05s-4,5.58-5.7,8-1.46,5.95-.85,8.5-5.58,2.91-5.58,2.91-8.74,4.25-11.9,4.13S744.47,626,744.47,626s-12.86-.73-15.29.61-11.78,1.58-11.78,1.58c-18.32,5.21-22.45-3.65-23.3-5.47s3.64-9.22,3.64-9.22,1-9.35,2.91-10.08,4.25-13.1,4.25-13.1-.73-3.77.85-5.83,1.46-7.89,3.52-10.68-2.18-12.14-1.45-14.57-2.31-12.26-2.07-14.81-.6-4.61-2.55-9.71c-1.66-4.35-1.19-23.68-1-29.22,0-.94.05-1.48.05-1.48s1.7-5.47,6.19-16.39c3.4-8.27,11.05-11.4,14.56-12.42a18.28,18.28,0,0,1,1.83-.45,12.85,12.85,0,0,1,2.58.65c3.54,1.19,10.62,4.56,20.72,14a155.32,155.32,0,0,1,12.63,13.32C783.53,529.49,785.39,517,785.39,517s1,2.28,5.69,11.38C793.59,533.22,794.05,539,793.61,544Z"
          transform="translate(-17.96 -172.03)"
          fill="#a36468"
        />
        <path
          d="M756.12,478l-22.84-18.22s-8.23,1-11.63,14.82l23.51,20.59Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M756.12,478l-4,5.59-4.06,5.73L745,493.81,726.23,478,723,475.2l-1.81-1.54c1.83-7.47,5.08-11.2,7.67-13a9.53,9.53,0,0,1,4-1.79Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.jacketColor}
        />
        <path
          d="M913.19,550.13c-19.06,5.7-44.91,3.28-44.91,3.28s-25.25,6.55-29.13,10c-2.5,2.19-15.27,3-24,3.33-4.85.18-8.48.19-8.48.19L812,545.4l3.08-.14c6.91-.32,23.2-1.14,25.2-1.81,2.55-.85,25.12-3.76,25.12-3.76S932.24,544.42,913.19,550.13Z"
          transform="translate(-17.96 -172.03)"
          fill="#efb7b9"
        />
        <path
          d="M793.27,546.68a22,22,0,0,1-2.19,7.09c-2.18,3.64-8.86,17.84-8.86,17.84L781.3,577a65.78,65.78,0,0,1-9-4.14L734.4,546.61s-14.69-9.59-26.1-30,12.14-28.4,12.14-28.4c13.71-5,41.51,25,42.6,30.83s14.45,13.11,25.37,23.91A22.2,22.2,0,0,0,793.27,546.68Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M793.61,544c-.09.95-.2,1.86-.34,2.73a22,22,0,0,1-2.19,7.09c-2.18,3.64-8.86,17.84-8.86,17.84l-.45,2.62a64.87,64.87,0,0,1-9.5-4.32L734.4,543.7s-14.69-9.59-26.1-30,12.14-28.41,12.14-28.41c13.71-5,41.51,25,42.6,30.83s14.45,13.11,25.37,23.92A21.89,21.89,0,0,0,793.61,544Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M809.29,544.55l-1.94,31.19-11.9,1a5.82,5.82,0,0,1-.81.35c-7.58,2.78-22.37-5.69-22.37-5.69L734.4,545.15s-14.69-9.59-26.1-30,12.14-28.4,12.14-28.4c13.71-5,41.51,25,42.6,30.83s14.45,13.11,25.37,23.91a21.79,21.79,0,0,0,5.46,4A14.91,14.91,0,0,0,809.29,544.55Z"
          transform="translate(-17.96 -172.03)"
          fill="#a36468"
        />
        <path
          d="M809.29,544.55l-1.94,31.19-11.9,1a5.82,5.82,0,0,1-.81.35l-.77-15.16s11.29-4.25,11.78-4.49-11.78-4.61-11.78-4.61v-7.25A14.91,14.91,0,0,0,809.29,544.55Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M815.1,566.69c-4.85.18-8.48.19-8.48.19L812,545.4l3.08-.14C817.06,548.67,816.21,558.69,815.1,566.69Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M794.84,552.8s12.26,4.37,11.78,4.61-11.78,4.49-11.78,4.49l.85,16.63,16.63-.91s6.07-30.28.85-33.32l-18.33-.85Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.jacketColor}
        />
        <path
          d="M722.14,572.71s-4.13,3.88-7.53,4.91Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M712.31,584.24s10.07-.37,11.28-2.43S712.31,584.24,712.31,584.24Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M707.33,598.68c.61,0,12.74-1.7,13.23-3.28Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M703.57,607.91c4.37-.13,11.77-4.86,11.77-4.86Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M731.85,610.33s26.34,0,27.55-4.85S731.85,610.33,731.85,610.33Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M751.63,542.48c.49,0,20.76,0,22.7-2.79S751.63,542.48,751.63,542.48Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M729.31,463a19.37,19.37,0,0,1,.26,3,18.58,18.58,0,0,1-.3,3.33,28.83,28.83,0,0,1-1.88,6.07l-.21.49c-.3.7-.62,1.38-.95,2.06a56.65,56.65,0,0,1-5.24,8.64,94.48,94.48,0,0,1-15.72,16.35q-1.53,1.29-3.09,2.55c0-.94.05-1.48.05-1.48s1.7-5.47,6.19-16.39c3.4-8.27,11.05-11.4,14.56-12.42l-1.81-1.54c1.83-7.47,5.08-11.2,7.67-13C729,461.4,729.19,462.18,729.31,463Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M790.6,415.92a3.52,3.52,0,0,0-.88.35c-1.9,1.05-2.45,3.54-4,5.11-1.79,1.85-4.59,2.13-7.14,2.45s-5.4.95-6.75,3.14c-1,1.63-.91,3.68-1.27,5.56a1.77,1.77,0,0,1-.39.92,1.8,1.8,0,0,1-1.22.4c-5,.35-8.64-1.37-13.32-2.58-2.2-.56-4.76-.49-6.44,1-1.52,1.37-1.94,3.61-1.9,5.66v.18a38.64,38.64,0,0,1,.18,6,9.9,9.9,0,0,1-5.23,7.33,9.25,9.25,0,0,1-3.78,1.08,3.06,3.06,0,0,1-1.5-.22c.89-1.52,1.74-3,2.52-4.51a30.11,30.11,0,1,1,51.08-31.88Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M798.84,412.08a5.08,5.08,0,0,1-1.67,2.05c-2.28,1.48-5.55-.15-7.93,1.17-1.91,1.05-2.45,3.54-4,5.11-1.78,1.85-4.58,2.13-7.14,2.45s-5.39.95-6.75,3.14c-1,1.63-.9,3.67-1.27,5.56a1.69,1.69,0,0,1-.39.92,1.83,1.83,0,0,1-1.22.4c-5,.35-8.64-1.38-13.32-2.58-2.19-.56-4.75-.49-6.43,1s-1.94,3.62-1.91,5.67a43.82,43.82,0,0,1,.19,6.16,10,10,0,0,1-9,8.41,2.46,2.46,0,0,1-1.85-.47,2.65,2.65,0,0,1-.61-1.1c-3.33-9.36-3.3-19.75-7.34-28.83a32.59,32.59,0,0,1-1.69-4c-.08-.28-.16-.57-.22-.86a13.14,13.14,0,0,1-.24-1.75,2.5,2.5,0,0,0-1.14.47,2.1,2.1,0,0,0-.32.34,5.93,5.93,0,0,0-.84,3.17,120,120,0,0,0,3.6,37.17,38.86,38.86,0,0,1,1.73,9.33,24.93,24.93,0,0,1-2.4,9.89c-6.27,14.46-18.87,25.05-31.4,34.62A13.93,13.93,0,0,0,699,499.19a4.08,4.08,0,0,1-3.17,2.84,12.22,12.22,0,0,1-4.47-.07c1.92-.63,2.67-2.89,3.15-4.85q1.47-6,2.73-12.11A76.26,76.26,0,0,0,699,473.18c.15-3.38-.11-6.77-.25-10.16a205.65,205.65,0,0,1,1-27.85c.74-8,2.08-16.65,7.95-22.11a34.54,34.54,0,0,1,8.4-5.24c0-1,7.33-3,8.3-3.14a7.88,7.88,0,0,1,1.22-.14,2.51,2.51,0,0,1,2.61,1.37c.36-.65.76-1.29,1.18-1.9a22.14,22.14,0,0,1,1.9-2.39c3.81-4.2,8.75-7.16,13.16-10.72a33.84,33.84,0,0,1,5.24-3.86,18.86,18.86,0,0,1,7.85-2,31.85,31.85,0,0,1,13.25,2.08c6.08,2.34,11.39,6.54,17.68,8.24a42.07,42.07,0,0,1,4.59,1.27,11.12,11.12,0,0,1,5.8,15.42Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.dark}
        />
        <g opacity="0.1">
          <path
            d="M697.57,501.65a13.82,13.82,0,0,0,.91-5.9,4.1,4.1,0,0,1-3.18,2.84,6.49,6.49,0,0,1-1.16.17c-.5,1.6-1.29,3.14-2.82,3.64a12.23,12.23,0,0,0,4.47.08A5,5,0,0,0,697.57,501.65Z"
            transform="translate(-17.96 -172.03)"
          />
          <path
            d="M799.56,404.11a11.18,11.18,0,0,1-1.2,4.54,5.15,5.15,0,0,1-1.68,2c-2.27,1.48-5.55-.14-7.93,1.17-1.9,1.05-2.45,3.55-4,5.11-1.79,1.85-4.59,2.14-7.14,2.45s-5.4,1-6.75,3.14c-1,1.63-.91,3.68-1.27,5.56a1.4,1.4,0,0,1-1.61,1.33c-5,.35-8.64-1.38-13.32-2.59-2.2-.56-4.76-.49-6.44,1-1.52,1.38-1.94,3.61-1.9,5.67a42.18,42.18,0,0,1,.18,6.15,9.94,9.94,0,0,1-9,8.42,2.49,2.49,0,0,1-1.85-.47,2.69,2.69,0,0,1-.61-1.11c-3.33-9.36-3.31-19.75-7.35-28.82a35,35,0,0,1-1.68-4,11.74,11.74,0,0,1-.47-2.61,2.2,2.2,0,0,0-1.46.81,6.14,6.14,0,0,0-.84,3.17,120.69,120.69,0,0,0,1,24,121,121,0,0,1-.49-20.14,5.93,5.93,0,0,1,.84-3.17,2.1,2.1,0,0,1,1.46-.81,11.82,11.82,0,0,0,.46,2.61,34.22,34.22,0,0,0,1.69,4c4,9.08,4,19.46,7.34,28.82a2.76,2.76,0,0,0,.62,1.11A2.42,2.42,0,0,0,738,452a10,10,0,0,0,9-8.41,43.82,43.82,0,0,0-.19-6.16c0-2.06.39-4.29,1.91-5.67,1.68-1.52,4.24-1.58,6.43-1,4.68,1.2,8.3,2.93,13.32,2.58a1.83,1.83,0,0,0,1.22-.4,1.73,1.73,0,0,0,.39-.93c.37-1.88.26-3.93,1.27-5.55,1.36-2.19,4.2-2.83,6.75-3.15s5.36-.59,7.15-2.44c1.51-1.57,2.05-4.06,4-5.12,2.37-1.31,5.65.32,7.93-1.16a5.08,5.08,0,0,0,1.67-2.05A11.34,11.34,0,0,0,799.56,404.11Z"
            transform="translate(-17.96 -172.03)"
          />
          <path
            d="M728.6,461.6a25,25,0,0,1-2.39,9.89c-5.61,12.93-16.29,22.77-27.44,31.54a14,14,0,0,1-3.48,7c12.52-9.56,25.14-20.15,31.4-34.61a24.93,24.93,0,0,0,2.4-9.89,21.9,21.9,0,0,0-.51-4.35C728.59,461.28,728.6,461.44,728.6,461.6Z"
            transform="translate(-17.96 -172.03)"
          />
        </g>
        <path
          d="M729.85,404c-.9,4.14-2.14,9.52-3.07,12.29a15,15,0,0,1-.24-1.75,2.47,2.47,0,0,0-1.13.47c0-2.91.35-7.24.65-10.48a2.52,2.52,0,0,1,2.62,1.37C729,405.26,729.43,404.62,729.85,404Z"
          transform="translate(-17.96 -172.03)"
          opacity="0.1"
        />
        <path
          d="M729.37,404c-.9,4.14-2.14,9.52-3.07,12.29a13.14,13.14,0,0,1-.24-1.75,2.5,2.5,0,0,0-1.14.47c0-2.91.35-7.24.66-10.48a2.51,2.51,0,0,1,2.61,1.37C728.55,405.26,729,404.62,729.37,404Z"
          transform="translate(-17.96 -172.03)"
          fill={theme.jacketColor}
        />
        <g opacity="0.7">
          {/* Power BI Logo Background */}
          <rect
            x="933"
            y="179.57"
            width="165.67"
            height="161.14"
            transform="translate(-167.6 -120.78)"
            fill="#F7F7F7"
          />
          <rect
            x="925.51"
            y="172"
            width="180.73"
            height="176.24"
            transform="translate(-167.6 -120.78)"
            fill="none"
            stroke="#F2C811"
            strokeWidth="7.53"
          />

          {/* Power BI Icon - Three bars */}
          <g transform="translate(765, 7.54)">
            <rect x="25" y="60" width="22" height="75" fill="#F2C811" />
            <rect x="55" y="80" width="22" height="55" fill="#E97627" />
            <rect x="85" y="95" width="22" height="40" fill="#FFB900" />
          </g>

          {/* Power BI Text */}
          <text
            x="1015.5"
            y="330"
            transform="translate(-167.6 -120.78)"
            fontSize="22"
            fontWeight="bold"
            fill="#F2C811"
            textAnchor="middle"
          >
            Power BI
          </text>
        </g>

        {/* Replace the Sketch diamond section with Tableau: */}
        <g opacity="0.7">
          {/* Tableau Logo - Modern T shape */}
          <g transform="translate(78, 11)">
            {/* Horizontal bar */}
            <rect x="0" y="30" width="113" height="12" fill="#E97627" />
            {/* Vertical bar */}
            <rect x="50" y="30" width="12" height="100" fill="#F28E2B" />
            {/* Top accent */}
            <rect x="20" y="20" width="30" height="8" fill="#59879B" />
            <rect x="62" y="20" width="30" height="8" fill="#59879B" />
            {/* Bottom accents */}
            <rect x="20" y="135" width="20" height="8" fill="#59879B" />
            <rect x="72" y="135" width="20" height="8" fill="#59879B" />
            {/* Center square */}
            <rect x="46" y="26" width="20" height="20" fill="#E97627" />
          </g>

          {/* Tableau Text */}
          <text
            x="134"
            y="168"
            fontSize="20"
            fontWeight="bold"
            fill="#E97627"
            textAnchor="middle"
          >
            Tableau
          </text>
        </g>
      </svg>
    );
  }
}
